export default __webpack_public_path__ + "static/media/SiteClearance.8e2a553d.jpg";